var isServer = typeof window === "undefined";
var isClient = typeof window !== "undefined";
var isProduction = process.env.NODE_ENV === "production";
var isTouch = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
export var Env = { isServer: isServer, isClient: isClient, isProduction: isProduction, isTouch: isTouch };
